import AxiosOICStat from "../AxiosOICStat";

const API_BASE = `${window.location.protocol}//${window.location.hostname}${import.meta.env.VITE_API_URL}`;

export function getLang() {
  return localStorage.getItem("language") || "en";
}

export async function fetchOicCountries(lang = getLang()) {
  const response = await AxiosOICStat.get("/cif/oic-countries", { params: { lang } });
  return response.data;
}

export function getFlagUrl(cCode) {
  return `${API_BASE}cif/${cCode}/flag`;
}
